import React from "react"
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

const AdjustmentDetailModal = ({ data, open, setOpen }) => {
  return (
    <Modal
      isOpen={open}
      role="dialog"
      autoFocus={true}
      centered={true}
      tabIndex="-1"
      toggle={() => {
        setOpen(!open)
      }}
      size="lg"
    >
      <div>
        <ModalHeader
          toggle={() => {
            setOpen(!open)
          }}
        >
          Adjustment Summary
        </ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <Row style={{ justifyContent: "center", textAlign: "center" }}>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Item Category</h6>
                  <p className="detailValue">{data?.item_category?.name}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Item</h6>
                  <p className="detailValue">{data?.item?.item_name}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Type</h6>
                  <p className="detailValue">{data?.adjustment_type}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Quantity</h6>
                  <p className="detailValue">{data?.qty}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Reason</h6>
                  <p className="detailValue">{data?.reason}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Note</h6>
                  <p className="detailValue">{data?.note}</p>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

export default AdjustmentDetailModal
